import { httpGet } from '../api/axios_api';
import Constants from '../../constants/constants';
import actions from './result_view_actions';

export const getResultsView = (playerID, page) => {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-results/${playerID}/${page}`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.ADD_RESULTS_TO_LIST,
          results: response.data.results,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
};
